import { Component } from "vue-property-decorator";
import { Getter, Mutation, Action } from "vuex-class";
import BasePage from "@/views/BasePage/BasePage";
import { configService } from "@/settings/api-url";
import Loading from "@/components/loading/loading";

@Component({
  components: {
    Loading,
  },
})
export default class LoginAccount extends BasePage {
  @Action action_getLoginCodeCell;
  @Action action_getLoginTemporaryCode;
  @Getter getPathTemporal;
  @Mutation PATH_TEMPORAL;

  isUser = true;
  loading = false;
  cellphone = "";
  code = "";
  email = "";
  password = "";

  mounted() {
    const route = this.$route.params;
    this.cellphone = route.cell;
    this.code = route.code;
    this.email = route.email;
  }

  _routeLogin() {
    if (this.getPathTemporal) {
      this.$router.push(this.getPathTemporal);
      this.PATH_TEMPORAL(null);
    } else {
      this.$router.push({ name: "root" });
    }
  }

  async _send() {
    try {
      this.loading = true;
      await this.action_getLoginTemporaryCode({
        password: this.password,
        temporary_code: this.code,
      });
      this._routeLogin();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$swal({
        title: "Oops...",
        text: error.response.data.message,
        timer: 3200,
      });
    }
  }

  async _sendCell() {
    try {
      this.loading = true;
      const cell = this.cellphone;
      await this.action_getLoginCodeCell(cell);
      this.$router.push({ name: "loginCellCode", params: { type: cell } });
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$swal({
        title: "Oops...",
        text: error.reponse.data.message,
        timer: 3200,
      });
    }
  }

  _onClose() {
    localStorage.removeItem("_tc");
    // remove the axios default heade
    delete configService.defaults.headers.common["Authorization"];
    this.$router.push({ name: "login" });
  }
}
